module.exports = __webpack_public_path__ + "static/Walmart_pin_hover-12eff59b08c43aff057a84f6b12f665e.png";